import { createSelector } from '@ngrx/store';

import { HomeSimulation } from '@models/swagger';
import { State } from './reducer';
import { selectSimulationState } from '../selectors';

export const getData = createSelector(selectSimulationState, (state: State) => state.data);

export const getError = createSelector(selectSimulationState, (state: State) => state.error);

export const getLoading = createSelector(selectSimulationState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: HomeSimulation[]) => T) =>
  createSelector(selectSimulationState, (state: State) => fn(state.data));
